import { createSlice } from "@reduxjs/toolkit";
import { validateInvite, acceptInvite, teamLogin, sendInvite, listMembers } from "../thunks/teamActions";

const teamSlice = createSlice({
  name: "team",
  initialState: {
    loading: false,
    inviteInfo: null,
    user: null,
    token: "",
    members: [],
    error: "",
    success: false
  },
  reducers: {
    teamReset(state) {
      state.loading = false;
      state.inviteInfo = null;
      state.user = null;
      state.token = "";
      state.members = [];
      state.error = "";
      state.success = false;
    }
  },
  extraReducers: (b) => {
    b.addCase(validateInvite.pending, (s)=>{ s.loading = true; s.error=""; })
     .addCase(validateInvite.fulfilled, (s,a)=>{ s.loading = false; s.inviteInfo = a.payload; })
     .addCase(validateInvite.rejected, (s,a)=>{ s.loading = false; s.error = a.payload?.error || "Invalid invite"; })

     .addCase(acceptInvite.pending, (s)=>{ s.loading = true; s.error=""; })
     .addCase(acceptInvite.fulfilled, (s,a)=>{ s.loading=false; s.user=a.payload.user; s.token=a.payload.token; s.success=true; })
     .addCase(acceptInvite.rejected, (s,a)=>{ s.loading=false; s.error=a.payload?.error || "Accept failed"; })

     .addCase(teamLogin.pending, (s)=>{ s.loading = true; s.error=""; })
     .addCase(teamLogin.fulfilled, (s,a)=>{ s.loading=false; s.user=a.payload.user; s.token=a.payload.token; s.success=true; })
     .addCase(teamLogin.rejected, (s,a)=>{ s.loading=false; s.error=a.payload?.error || "Login failed"; })

     .addCase(sendInvite.pending, (s)=>{ s.loading=true; s.error=""; })
     .addCase(sendInvite.fulfilled, (s)=>{ s.loading=false; s.success=true; })
     .addCase(sendInvite.rejected, (s,a)=>{ s.loading=false; s.error=a.payload?.error || "Invite failed"; })

     .addCase(listMembers.pending, (s)=>{ s.loading=true; s.error=""; })
     .addCase(listMembers.fulfilled, (s,a)=>{ s.loading=false; s.members=a.payload; })
     .addCase(listMembers.rejected, (s,a)=>{ s.loading=false; s.error=a.payload?.error || "Fetch members failed"; });
  }
});

export const { teamReset } = teamSlice.actions;
export default teamSlice.reducer;
